'use client';

import { showModal, showToast } from '@/redux/navigationSlice';
import { pushTaxpayerId } from '@/redux/prospectSlice';
import {
  login,
  loginParams,
  prospectErrorMessage,
  prospectErrorResponse,
  type loginResponse,
} from '@repo/prospects-api';
import { Login } from '@repo/ui';
import { deleteClientCookie } from '@repo/utils';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const loginErrorModal: Record<string, string> = {
  UNAUTHORIZED_REJECTED_MISSING_DOCUMENTATION: 'Tu solicitud no pudo avanzar porque falta documentación requerida',
  UNAUTHORIZED_REJECTED_DOCUMENT_NOT_CORRECTED:
    'Se solicitaron correcciones sobre la documentación presentada y no fueron recibidas',
  UNAUTHORIZED_REJECTED_CONTRACT_NOT_SIGNED: 'No se recibió la firma del contrato necesaria para finalizar el alta',
  UNAUTHORIZED_REJECTED_DISCARDED: 'Luego de la evaluación realizada, no fue posible continuar con el proceso de alta',
};

export default function Page(): React.JSX.Element {
  const router = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    deleteClientCookie('token-prospects');
  }, []);

  const handleError = (res: prospectErrorResponse) => {
    const { message } = res;
    if (message in loginErrorModal) {
      dispatch(showModal({ body: 'prospectRejected', title: loginErrorModal[message] || '' }));
      return;
    }

    dispatch(
      showToast({ kind: 'error', text: prospectErrorMessage[res?.message] || 'El CUIT ingresado no fue reconocido' }),
    );
  };

  return (
    <Login<loginResponse & prospectErrorResponse, loginParams>
      noPassword
      useCredentialType={true}
      credentialType="taxpayerId"
      connector={login}
      callback={(_, taxpayerId) => {
        dispatch(pushTaxpayerId(taxpayerId || ''));
        router.push('/otp');
      }}
      onError={handleError}
    />
  );
}
